export default "__VITE_ASSET__BCTNuSb4__"